import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assign-mysteryshopper',
  templateUrl: './assign-mysteryshopper.component.html',
  styleUrls: ['./assign-mysteryshopper.component.scss']
})
export class AssignMysteryshopperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
